import {
  IReportBuilderFormik,
  TGroupingsState,
  TGroupingItem,
} from 'domains/ReportBuilder/types';
import { FormikProps } from 'formik';
import React, { FC } from 'react';
import { RenderCatalogGrouping } from '../../RenderFilterType/RenderCatalogGrouping';
import { RenderTarget } from '../../RenderFilterType/RenderTarget';
import { RenderDynamicCatalog } from '../../RenderFilterType/RenderDynamicCatalog/RenderDynamicCatalog';
import { RenderNo } from '../../RenderFilterType/RenderNo';

interface IGroupingsProps {
  formik: FormikProps<IReportBuilderFormik>;
  groupings: TGroupingsState;
  groupBy: IReportBuilderFormik['reportFilters']['groupBy'];
}

const Groupings: FC<IGroupingsProps> = ({ formik, groupings, groupBy }) => {
  const renderGrouping = (key: string, groupingItem: TGroupingItem) => {
    if (!groupingItem) return null;

    const { type } = groupingItem;
    const currentValue = groupBy[key];

    if (type === 'catalog') {
      return (
        <RenderCatalogGrouping
          item={groupingItem}
          currentValue={currentValue}
          formikKey="groupBy"
          currentKey={key}
          setFieldValue={formik.setFieldValue}
        />
      );
    }

    if (type === 'target') {
      return (
        <RenderTarget
          item={groupingItem}
          formikKey="groupBy"
          currentKey={key}
        />
      );
    }

    if (type === 'no') {
      return (
        <RenderNo
          formik={formik}
          item={groupingItem}
          currentValue={currentValue}
          formikKey="groupBy"
          currentKey={key}
        />
      );
    }

    if (type === 'dynamic_catalog') {
      return (
        <RenderDynamicCatalog
          item={groupingItem}
          currentValue={currentValue}
          formikKey="groupBy"
          currentKey={key}
          source={groupingItem.source || ''}
          formik={formik}
        />
      );
    }

    return null;
  };

  const noTypeLastSort = Object.entries(groupings).sort(([, a], [, b]) => {
    if (a.type === 'no') return 1;
    if (b.type === 'no') return -1;

    return 0;
  });

  return (
    <>
      {noTypeLastSort.map(([key, value]) => (
        <React.Fragment key={key}>{renderGrouping(key, value)}</React.Fragment>
      ))}
    </>
  );
};

export default Groupings;
